import type { HTMLAttributes, ReactNode } from 'react'
import clsx from 'clsx'
import styles from './Card.module.scss'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean
  flat?: boolean
  padding?: 'default' | 'compact' | 'none'
}

export function Card({ interactive, flat, padding = 'default', className, children, ...rest }: CardProps) {
  return (
    <div
      className={clsx(
        styles.card,
        interactive && styles.interactive,
        flat && styles.flat,
        padding === 'compact' && styles.compact,
        padding === 'none' && styles.noPadding,
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export interface CardHeaderProps {
  title: ReactNode
  subtitle?: ReactNode
  icon?: ReactNode
  actions?: ReactNode
  className?: string
}

export function CardHeader({ title, subtitle, icon, actions, className }: CardHeaderProps) {
  return (
    <div className={clsx(styles.header, className)}>
      <div className={styles.headerTitle}>
        {icon}
        <div style={{ minWidth: 0 }}>
          <div className={styles.title}>{title}</div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  )
}

export function CardBody({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={clsx(styles.body, className)} {...rest}>
      {children}
    </div>
  )
}

export function CardFooter({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={clsx(styles.footer, className)} {...rest}>
      {children}
    </div>
  )
}
